module.exports = __webpack_public_path__ + "videos/3d-model_jp-hevc.d869a44.mp4";